import script from "./SectionProductCard.vue?vue&type=script&setup=true&lang=js"
export * from "./SectionProductCard.vue?vue&type=script&setup=true&lang=js"

import "./SectionProductCard.vue?vue&type=style&index=0&id=3bf5682e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3bf5682e"]])

export default __exports__